const style = {
  homeHeader: {
    width: "100%",
    textAlign: "center",
    overflow: "hidden",
  },
};

export default style;
